import * as Sentry from '@sentry/react'
import { useEffect } from 'react'
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from 'react-router'
import log from 'loglevel'

import { EnvEnum, ENVIRONMENT, SENTRY_DSN, SENTRY_RELEASE } from 'app/utils/constants'
import { isNoisyOnfidoSdkFetchError, isNoisyPostHogRecorderLoadRaceError, isNoisyReplayCrossOriginSecurityError } from 'app/utils/sentryEventFiltering'

const replay = Sentry.replayIntegration({
    blockAllMedia: false,
    maskAllText: false,
    maskAllInputs: true,
    block: ['iframe[src*="freshchat.com"]', 'iframe[src*="braze.com"]']
})

Sentry.init({
    enabled: Boolean(SENTRY_DSN) && typeof window !== 'undefined',
    dsn: SENTRY_DSN,
    normalizeDepth: 5,
    beforeSend: (event) => {
        if (isNoisyReplayCrossOriginSecurityError(event) || isNoisyOnfidoSdkFetchError(event) || isNoisyPostHogRecorderLoadRaceError(event)) {
            return null
        }

        if (ENVIRONMENT === EnvEnum.LOCAL) {
            log.error('sentry event', event)
        }
        return event
    },
    integrations: [
        Sentry.extraErrorDataIntegration({ depth: 10 }),
        Sentry.httpClientIntegration({
            failedRequestStatusCodes: [[500, 599]],
            failedRequestTargets: ENVIRONMENT === EnvEnum.LOCAL ? ['http://localhost'] : [/fig\.ca/]
        }),
        Sentry.browserTracingIntegration(),
        Sentry.reactRouterV6BrowserTracingIntegration({
            useEffect,
            useLocation,
            useNavigationType,
            createRoutesFromChildren,
            matchRoutes
        }),
        replay
    ],
    tracePropagationTargets: ENVIRONMENT === EnvEnum.LOCAL ? ['localhost'] : [`api.${ENVIRONMENT.toLowerCase()}.fig.ca`],
    replaysOnErrorSampleRate: 1.0,
    tracesSampleRate: ENVIRONMENT !== EnvEnum.PRODUCTION ? 1.0 : 0.2,
    release: SENTRY_RELEASE,
    environment: ENVIRONMENT,
    denyUrls: ['https://consent.trustarc.com', 'https://fig-help.freshchat.com']
})

Sentry.setTag('service', 'frontend_v2')
